import { GoalDto } from "../../common/request/goal.dto";

export interface GetGoalSummariesRequestParamsDto {
    goals: GoalDto[];
}